import React from 'react';


//import NavbarM from '../pagecomp/homep/navbarm';

import '../pagecomp/homep/navbarms.css';
import NavbarMs from '../pagecomp/homep/navbarms';

import AboutInnov from '../pagecomp/landingpage/aboutinnvo';





function Aboutinnovpage() {
    return (
        <>
            <NavbarMs />

            <AboutInnov />
        </>
    )
}

export default Aboutinnovpage;